import PropTypes from "prop-types"
import React, {Component} from "react"

import Popup from "../Popup"

import "./Diagram.scss"


class Diagram extends Component {
  /*
  * Renders a Diagram that also opens up as a popup if clicked
  */
  constructor(props) {
    super(props)
    this.state = {
      zoomed: false
    }
  }

  render () {
    const {
      image,
      alt
    } = this.props
    const {
      zoomed
    } = this.state

    return (
      <>
        <div className="diagram__clicker" onClick={() => this.setState({zoomed: true})}>
          <img className="diagram" src={image} alt={alt}/>
          <span className="diagram__clicker-button">+</span>
        </div>
        {zoomed ?
          <Popup onDismiss={() => this.setState({zoomed: false})} modifiers={["screen"]}>
            <img className="diagram diagram--full" src={image} alt={alt}/>
          </Popup>
          : ""
        }
      </>
    )
  }
}


Diagram.propTypes = {
  image: PropTypes.string,
  alt: PropTypes.string
}


export default Diagram
